import { Button, StickyBarContent } from '@common/components';
import Portal from '@common/components/Portal';
import { ButtonWrapper } from '@features/DynamicPackagesConfigurationWizard/components/ExperienceDetails/ExperienceDetails.styles';
import { useGetSpaPackageExtras } from '@features/spa/hooks/useGetSpaPackageExtras';
import { useTranslations } from '@lang';
import { some } from '@utils/some';
import moment from 'moment';
import { SpaExtras } from '../ExtrasStep/Extras/SpaExtras';
import { ExtrasWrapper } from '../ExtrasStep/ExtrasSection.styles';
import { StyledDateRangeIndicator } from '../FormSteps.styles';
import { useHashNavigation } from '../hooks/useHashNavigation';
import { SpaExtrasWrapper } from './SpaExtrasStep.styles';
import { usePackageConfiguration, useWizardNavigation, useCurrentStep } from '../../contexts';

export const SpaExtrasStep = () => {
  const { property, journeyParams, spaPackageId, rate } = usePackageConfiguration();
  const { stickyBarId, handleNextStep, isLastStep } = useWizardNavigation();
  const { packageTotalPrice, hash, isSubmitting } = useCurrentStep();

  useHashNavigation({ hash });

  const { t } = useTranslations();

  const { data: extras = [] } = useGetSpaPackageExtras(
    property.id,
    Number(spaPackageId),
    property.defaultLanguage,
    moment(journeyParams.fromDate).format('YYYY-MM-DD'),
    true
  );

  return (
    <>
      <SpaExtrasWrapper>
        {some(extras) && (
          <ExtrasWrapper>
            <SpaExtras extras={extras} />
          </ExtrasWrapper>
        )}
      </SpaExtrasWrapper>
      <Portal selector={`#${stickyBarId}`}>
        <StickyBarContent
          name={rate.title || ''}
          subtitle={
            <StyledDateRangeIndicator
              fromDate={journeyParams.fromDate}
              toDate={journeyParams.toDate}
            />
          }
          displayedPrice={packageTotalPrice}
          button={
            <ButtonWrapper>
              <Button
                isPrimary
                onClick={handleNextStep}
                disabled={isSubmitting}
                isLoading={isSubmitting}
              >
                {isLastStep ? t('product.ctaButton') : t('spa.package.nextStep')}
              </Button>
            </ButtonWrapper>
          }
        />
      </Portal>
    </>
  );
};
